import React from "react";
import PropTypes from "prop-types";

function PlugScript({ assetHost }) {
    const script = `<script src="//${assetHost}/s3/fence/plug-client/v0/app.bundle.js" onload="(function() { window.plugClient.init(); })()" defer></script>`;

    return <div dangerouslySetInnerHTML={{ __html: script }}></div>;
}

PlugScript.propTypes = {
    assetHost: PropTypes.string,
};

export default PlugScript;
